module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1184.1642d666.png";